<div class="section-label">
  <span class="section-bar section-bar--insight"></span>
  <span>Performance &amp; Insight</span>
</div>

<section class="members-card">
  <header class="members-header">
    <h2 class="members-title">Members Over Time, by Product</h2>
    <div class="members-pills">
      <span class="members-pill">{{ scopeLabel }}</span>
      <span class="members-pill">Last 6 months</span>
    </div>
  </header>

  <div *ngIf="loading" class="flex items-center justify-center py-10">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  </div>

  <p *ngIf="!loading && !chart" class="members-empty">
    {{ emptyMessage }}
  </p>

  <apx-chart
    *ngIf="!loading && chart"
    [series]="chart.series"
    [chart]="chart.chart"
    [colors]="chart.colors"
    [dataLabels]="chart.dataLabels"
    [stroke]="chart.stroke"
    [markers]="chart.markers"
    [xaxis]="chart.xaxis"
    [yaxis]="chart.yaxis"
    [legend]="chart.legend"
    [grid]="chart.grid"
    [tooltip]="chart.tooltip">
  </apx-chart>
</section>
